export enum AboutYouSteps {
    BorrowerCitizenship = 'BC',
    BorrowerCurrentAddress = 'BCA',
    BorrowerMilitary = 'BM',
    BorrowerOwnership = 'BO',
    BorrowerPersonalInfo = 'BPO'
}